import { casePlaceholderPrefix } from "@/Case/store/casePlaceholderPrefix";

export const casePlaceholderRegex = new RegExp(`${casePlaceholderPrefix}\\d+`);
